import { Component, EventEmitter, Input, OnInit,Output } from '@angular/core';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css'],
  styles: [`:host {
      display: block;
      position: relative;
      width: 60px;
      height: 30px;
    }`]
})
export class ToggleComponent implements OnInit {
  @Output() changed = new EventEmitter<boolean>();
  @Input() initial: boolean = true;
  @Input() trueText: string = "";
  @Input() falseText: string = "";
  @Input() idForControl: string;
  constructor() { }

  ngOnInit(): void {
    
  }

  Toggle(checked: boolean) {
    debugger;
    //this.initial = checked;
    this.changed.emit(checked);
  }

}
